<button (click)="closeDialog()" class="close-icon">
        <img src="./assets/images/close cross.svg" alt="Unable to load image">
    </button>
<div class="district-official">
    <p class="heading">District Official Email</p>
    <div class="content row" *ngFor="let data of districtOfficials">
        <div class="col-lg-6 col-md-6 col-sm-10 name">{{data.firstName}} {{data.lastName}}</div>
        <div class="col-lg-6 col-md-6 col-sm-2 email">
            <a [href]="'mailto:'+data.email+'?subject=Fast Track Access Request&body=Please grant me campus-level access to the K-12 Fast Track Website. Applicable data provided below.%0D%0AFirst Name:%0D%0ALast Name:%0D%0AEmail Address:%0D%0ACampus:%0D%0APosition:%0D%0A'">{{data.email | lowercase}}</a></div>
    </div>
</div>